import React from 'react'
import { useAtomValue } from 'jotai'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@duck/ui'
import { debugDevEnabledAtom } from '@/store/debugAtoms'

interface DevPrintProps {
  label: string
  value?: string
}

export const DevPrint: React.FC<DevPrintProps> = ({ label, value }) => {
  const debugDevEnabled = useAtomValue(debugDevEnabledAtom)
  if (!debugDevEnabled || value === undefined) {
    return null
  }

  const handleCopy = () => {
    try {
      void navigator.clipboard.writeText(value)
    } catch {
      // noop – best-effort debug helper
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            onClick={handleCopy}
            className="inline-flex items-center text-[10px] text-warning font-mono cursor-pointer mb-1"
          >
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <span className="text-xs font-mono break-all">
            {value}
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

